import type { FeatureErrorMapper } from "src/lib/errors/types";

/**
 * Billing errors originate from edge-function invocations (checkout / portal),
 * not Postgres — so there are no SQLSTATE codes to match. We key off the action
 * to keep messages distinctive and reportable via the `[billing.*]` scope tag.
 */
export const billingErrorMapper: FeatureErrorMapper = (action, err) => {
  if (err.message.includes("No Stripe customer")) {
    return "Start a subscription before opening the billing portal.";
  }

  if (action === "checkout") {
    return "Couldn't start checkout. Please try again.";
  }

  if (action === "manage") {
    return "Couldn't open the billing portal. Please try again.";
  }

  return null;
};
